import React from 'react'
import { Modal, Button } from 'antd'
import rightIcon from 'assets/check/correct-icon.svg'
import errorIcon from 'assets/check/error-icon.svg'
import styles from './index.scss'
const subjectiveTitleType = type => ['填空', '综合'].includes(type)

const removeHTMLTag = (str: string) => {
  str = str.replace(/<\/?[^>]*>/g, '') // 去除HTML tag
  str = str.replace(/[ | ]*\n/g, '\n') // 去除行尾空白
  str = str.replace(/\n[\s| | ]*\r/g, '\n') // 去除多余空行
  str = str.replace(/ /gi, '') // 去掉
  return str
}

const FailModal = ({
  onClose,
  failureContent,
}: {
  onClose?: () => void
  failureContent: any
}) => {
  const content = (
    <div
      className={styles.failModal}
      style={{
        width: '100%',
        boxSizing: 'border-box',
        padding: 20,
        height: 440,
        overflowX: 'hidden',
        overflowY: 'scroll',
      }}
    >
      {Array.isArray(failureContent) &&
        failureContent.map((x, index) => (
          <div key={index} style={{ width: '100%', marginBottom: 46 }}>
            {/*<p>{index+1}.题目：{'xxx'} &nbsp;&nbsp;&nbsp;<span style={{backgroundImage: `url(${!subjectiveTitleType(x.type) ? (x.is_right ? rightIcon : errorIcon) : ''}})`}} /></p>*/}
            <p style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ maxWidth: '90%' }}>
                {index + 1}.题目：{x.content} &nbsp;&nbsp;&nbsp;
              </span>
              <span
                className={`${styles.resultIcon} ${
                  !subjectiveTitleType(x.type)
                    ? x.is_right
                      ? styles.rightIcon
                      : styles.errorIcon
                    : ''
                }`}
              />
            </p>
            <div className={styles.content}>
              <span>
                我的答案：
                <strong style={{ color: 'red' }}>
                  {x.examinee_answers.toString()
                    ? removeHTMLTag(x.examinee_answers.toString())
                    : '未填写'}
                </strong>
              </span>
              <span style={{ paddingLeft: 12 }}>
                参考答案：
                <strong style={{ color: 'red' }}>
                  {removeHTMLTag(x.answers.toString())}
                </strong>
              </span>
            </div>
          </div>
        ))}
    </div>
  )

  return content
}

export default FailModal
